import { useTranslation } from 'react-i18next';
import { AdminSettingsForm } from 'components/shared/AdminSettings/AdminSettingsForm';
import {
  ControlledCheckbox,
  ControlledDatePicker,
  ControlledSelect
} from 'components/shared/ControlledFields';
import { useFormContext } from 'react-hook-form';
import { Dispatch, useEffect } from 'react';
import { useSaveResource } from 'RestAPIs/useSaveResource';
import { SETTINGS_GROUP_IMPORT_EMPLOYEE } from '../useGetConnectionTableData';
import { AdminSettingsResponse } from '../../../../types';
import {
  transformAdminSettingsToFormValues,
  transformAdminSettingsToRequestValues
} from '../../../../utils';
import Skeleton from '@mui/material/Skeleton';
import { generalSchema } from '../utils';
import { ADMIN_SETTINGS_GROUP } from 'RestAPIs/endpoints';

type GeneralTabProps = {
  setAFASSelected: Dispatch<boolean>;
  tableData: AdminSettingsResponse;
  isFetching: boolean;
};
export const GeneralTab = ({
  setAFASSelected,
  tableData,
  isFetching
}: GeneralTabProps) => {
  const { mutateAsync: saveForm, isLoading } = useSaveResource({
    url: ADMIN_SETTINGS_GROUP,
    id: tableData[0]?.groupId,
    invalidateQueryKey: [SETTINGS_GROUP_IMPORT_EMPLOYEE]
  });

  const onSubmit = async (data) => {
    await saveForm({
      ...tableData[0],
      settings: transformAdminSettingsToRequestValues(
        data,
        tableData[0].settings
      )
    });
  };

  return isFetching ? (
    <Skeleton />
  ) : (
    <AdminSettingsForm
      schema={generalSchema}
      submitForm={onSubmit}
      isLoading={isLoading}
      data={transformAdminSettingsToFormValues(tableData[0])}
    >
      <FormFields setAFASSelected={setAFASSelected} />
    </AdminSettingsForm>
  );
};

const FormFields = ({ setAFASSelected }) => {
  const { t } = useTranslation('common', { keyPrefix: 'employeeSettings' });
  const { control, watch } = useFormContext();

  const typeWatch = watch('import_employee_type');

  useEffect(() => {
    setAFASSelected(typeWatch === 'AFAS');
  }, [typeWatch]);

  return (
    <>
      <ControlledSelect
        control={control}
        name="import_employee_type"
        label={t('employeeImportType')}
        options={[
          { value: 'SDB', label: 'SDB' },
          {
            value: 'AFAS',
            label: 'AFAS'
          }
        ]}
      />
      <ControlledDatePicker
        fullWidth
        control={control}
        name="import_employee_startDate"
        label={t('startDate')}
      />
      <ControlledCheckbox
        control={control}
        name="import_employee_createMissingContext"
        label={t('enableCreation')}
      />
    </>
  );
};
